"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shoppingCartTypes = exports.USE_STRIPE_PURSHACE = exports.USE_PRIMARY_COLOR = exports.USE_OUTLINED_BUTTON = exports.STORE_PAGE = exports.STATIC_PATH = exports.SHIPPING_OPTION_UUID = exports.SHIPPING_CHOICE_ASK_ADDRESS_UUID = exports.SELLER_PAGE = exports.SELLER_NAME_DISPLAY = exports.PROPOSITIONS_USED_IN_CHAT = exports.PAYMENT_MODE = exports.PAYMENT_METHODS = exports.PAYMENT_METHOD = exports.KITTY_EXCHANGE_RATE = exports.KITTY_ENABLED = exports.HIDE_COUPON = exports.DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL = exports.COUPON_ENABLED = exports.CONTINUE_SHOPPING_LINK = exports.COMMISSION_CLASS_NAME = exports.COMMISSION_BEFORE_PURCHASE_TIME = exports.BASE_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var BASE_URL = (0, _Utils.getBackendConfig)('REACT_BASE_URL', process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var STATIC_PATH = process.env.PUBLIC_URL || '';
exports.STATIC_PATH = STATIC_PATH;
var USE_STRIPE_PURSHACE = process.env.REACT_APP_USE_STRIPE_PURSHACE === "true" ? true : false;
exports.USE_STRIPE_PURSHACE = USE_STRIPE_PURSHACE;
var SHIPPING_OPTION_UUID = (0, _Utils.getBackendConfig)('SHIPPING_OPTION_UUID', process.env.REACT_APP_SHIPPING_OPTION_UUID || null);
exports.SHIPPING_OPTION_UUID = SHIPPING_OPTION_UUID;
var SHIPPING_CHOICE_ASK_ADDRESS_UUID = (0, _Utils.getBackendConfig)('SHIPPING_CHOICE_OTHER', process.env.REACT_APP_SHIPPING_CHOICE_ASK_ADDRESS_UUID || null);
exports.SHIPPING_CHOICE_ASK_ADDRESS_UUID = SHIPPING_CHOICE_ASK_ADDRESS_UUID;
var COUPON_ENABLED = (0, _Utils.getBackendConfig)('COUPON_ENABLED', process.env.REACT_APP_COUPON_ENABLED || false);
exports.COUPON_ENABLED = COUPON_ENABLED;
var KITTY_EXCHANGE_RATE = (0, _Utils.getBackendConfig)('KITTY_EXCHANGE_RATE', process.env.REACT_APP_KITTY_EXCHANGE_RATE || null);
exports.KITTY_EXCHANGE_RATE = KITTY_EXCHANGE_RATE;
var KITTY_ENABLED = (0, _Utils.getBackendConfig)('KITTY_ENABLED', process.env.REACT_APP_KITTY_ENABLED || false);
exports.KITTY_ENABLED = KITTY_ENABLED;
var HIDE_COUPON = (0, _Utils.getBackendConfig)('HIDE_COUPON', process.env.REACT_APP_HIDE_COUPON || false);
exports.HIDE_COUPON = HIDE_COUPON;
var PAYMENT_METHODS = {
  MANGOPAY: 'MANGOPAY',
  STRIPE: 'STRIPE',
  INTERNAL_PAYMENT: 'INTERNAL_PAYMENT',
  INTERNAL_PAYMENT_WITH_STRIPE_CARD_ONLY: 'INTERNAL_PAYMENT_WITH_STRIPE_CARD_ONLY' // I added this payment method to handle internal payment with caution (stripe) for swaptheroad
};
exports.PAYMENT_METHODS = PAYMENT_METHODS;
var PAYMENT_METHOD = (0, _Utils.getBackendConfig)('PAYMENT_METHOD', process.env.REACT_APP_PAYMENT_METHOD || PAYMENT_METHODS.MANGOPAY);
exports.PAYMENT_METHOD = PAYMENT_METHOD;
var CONTINUE_SHOPPING_LINK = process.env.REACT_APP_CONTINUE_SHOPPING_LINK || 'products';
exports.CONTINUE_SHOPPING_LINK = CONTINUE_SHOPPING_LINK;
var DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL = process.env.REACT_APP_DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL;
exports.DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL = DEFAULT_IMAGE_FOR_SHOPPING_CART_ITEM_URL;
var STORE_PAGE = process.env.REACT_APP_STORE_PAGE || "users";
exports.STORE_PAGE = STORE_PAGE;
var SELLER_PAGE = process.env.REACT_APP_SELLER_PAGE || STORE_PAGE;
exports.SELLER_PAGE = SELLER_PAGE;
var PROPOSITIONS_USED_IN_CHAT = process.env.REACT_APP_PROPOSITIONS_USED_IN_CHAT || false;
exports.PROPOSITIONS_USED_IN_CHAT = PROPOSITIONS_USED_IN_CHAT;
var COMMISSION_CLASS_NAME = "Commission";
exports.COMMISSION_CLASS_NAME = COMMISSION_CLASS_NAME;
var COMMISSION_BEFORE_PURCHASE_TIME = "before_purchase";
exports.COMMISSION_BEFORE_PURCHASE_TIME = COMMISSION_BEFORE_PURCHASE_TIME;
var SELLER_NAME_DISPLAY = process.env.REACT_APP_SELLER_NAME_DISPLAY || "NP";
exports.SELLER_NAME_DISPLAY = SELLER_NAME_DISPLAY;
var shoppingCartTypes = [{
  path: 'salable-product',
  cartName: 'Cart 1',
  welletId: '1',
  paymentMethod: PAYMENT_METHODS.MANGOPAY,
  shoppingMethod: process.env.REACT_APP_SHOPPING_METHOD || 'NULL'
}];
exports.shoppingCartTypes = shoppingCartTypes;
var PAYMENT_MODE = (0, _Utils.getBackendConfig)('PAYMENT_MODE', process.env.REACT_APP_PAYMENT_MODE || null);
exports.PAYMENT_MODE = PAYMENT_MODE;
var USE_PRIMARY_COLOR = process.env.REACT_APP_USE_PRIMARY_COLOR;
exports.USE_PRIMARY_COLOR = USE_PRIMARY_COLOR;
var USE_OUTLINED_BUTTON = process.env.REACT_APP_USE_OUTLINED_BUTTON;
exports.USE_OUTLINED_BUTTON = USE_OUTLINED_BUTTON;